export default "__VITE_ASSET__bdee006b__"